export default {
    namespaced: true,

    state: {
        data: {
            last_name: "",
            first_name: "",
            middle_name: "",
            birth_date: "",
            phone: "",
            email: "",
            passport_series: "",
            passport_number: "",
            passport_subdivision_code: "",
            passport_subdivision_title: "",
            passport_date: "",
            address: "",
            is_middle_name_required: false,

            passport_photo_files: [],

            passport_address_files: [],

            transaction_date: "",

            transaction_provider_option: {
                text: null,
                id: null,
                icon: null,
                selected: false,
            },

            transaction_id: "",
            transaction_summ: "",
            transaction_document_copy_attached: true,
            no_transaction_document_reason: "",

            transaction_document_files: [],

            refund_cause: "",
            card_number: "",
            transaction_last_name: "",
            transaction_first_name: "",
            transaction_middle_name: "",
            transaction_is_middle_name_required: false,

            transaction_phone: "",
            client_rs_number: "",
            bank_bik: "",
            bank_title: "",

            mobile_phone_provider: "",

            offer_name: "",
            offer_id: "",
            comment: "",

            active_tab: null,

            mobile_tabs_option: {
                text: null,
                id: null,
                icon: false,
                selected: false,
            },

            pd_agreement: false,
        },

        data_send: false
    },

    actions: {
        async REFUND_SEND_DATA_ACT({ commit, dispatch }, sendData) {
            commit("setDataSend", { bool: false })
            
            try {
                let res = await BX.ajax.runComponentAction("vedita:application", "save", {
                    mode: "class",
                    data: {
                        post: sendData, //данные
                    },
                });
                commit("setDataSend", { bool: true })
            } catch (error) {
                dispatch("errorController/aggregateErrors", { error: error }, { root: true });
            }
        },
    },

    mutations: {
        setFirstStepData(state, { data }) {
            state.data.last_name = data.last_name;
            state.data.first_name = data.first_name;
            state.data.middle_name = data.middle_name;
            state.data.birth_date = data.birth_date;
            state.data.phone = data.phone;
            state.data.email = data.email;
            state.data.passport_series = data.passport_series;
            state.data.passport_number = data.passport_number;
            state.data.passport_subdivision_code = data.passport_subdivision_code;
            state.data.passport_subdivision_title = data.passport_subdivision_title;
            state.data.passport_date = data.passport_date;

            state.data.passport_photo_files = data.passport_photo_files;
            state.data.passport_address_files = data.passport_address_files;

            state.data.address = data.address;
            state.data.is_middle_name_required = data.is_middle_name_required;
        },

        setSecondStepData(state, { data }) {
            state.data.transaction_date = data.transaction_date;

            state.data.transaction_provider_option.text = data.transaction_provider_option.text;
            state.data.transaction_provider_option.id = data.transaction_provider_option.id;
            state.data.transaction_provider_option.icon = data.transaction_provider_option.icon;
            state.data.transaction_provider_option.selected = data.transaction_provider_option.selected;

            state.data.transaction_id = data.transaction_id;
            state.data.transaction_summ = data.transaction_summ;
            state.data.transaction_document_copy_attached = data.transaction_document_copy_attached;
            state.data.no_transaction_document_reason = data.no_transaction_document_reason;

            state.data.transaction_document_files = data.transaction_document_files;

        },

        setThirdStepData(state, { data }) {
            state.data.refund_cause = data.refund_cause;
            state.data.card_number = data.card_number;
            state.data.transaction_last_name = data.transaction_last_name;
            state.data.transaction_first_name = data.transaction_first_name;
            state.data.transaction_middle_name = data.transaction_middle_name;
            state.data.is_transaction_middle_name_required = data.is_transaction_middle_name_required;

            state.data.transaction_phone = data.transaction_phone;
            state.data.client_rs_number = data.client_rs_number;
            state.data.bank_bik = data.bank_bik;
            state.data.bank_title = data.bank_title;
            state.data.mobile_phone_provider = data.mobile_phone_provider;
            state.data.offer_name = data.offer_name;
            state.data.offer_id = data.offer_id;
            state.data.comment = data.comment;
            state.data.active_tab = data.active_tab;
            state.data.mobile_tabs_option.text = data.mobile_tabs_option.text;
            state.data.mobile_tabs_option.id = data.mobile_tabs_option.id;
            state.data.mobile_tabs_option.icon = data.mobile_tabs_option.icon;
            state.data.mobile_tabs_option.selected = data.mobile_tabs_option.selected;
        },

        setFourStepData(state, { data }) {
            state.data.pd_agreement = data.pd_agreement;
        },

        setDataSend(state, { bool }) {
            state.data_send = bool;
        },
    },
};
